import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { TableActionType as ta } from '@/util/enum';
import { DefaultListFeilds as df, Status } from '../../types';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '收款单号',
            dataIndex: df.id,
            key: df.id,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '企业名称',
            dataIndex: df.companyName,
            key: df.companyName,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交款总额（元）',
            dataIndex: df.totalAmount,
            key: df.totalAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: df.stateDesc,
            key: df.stateDesc,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '业务类型',
            dataIndex: df.businessTypeDesc,
            key: df.businessTypeDesc,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收款日期',
            dataIndex: df.collectionTime,
            key: df.collectionTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: cellWidth.big,
            align: 'center',
            fixed: 'right',
            render: (text, item) => this._renderActionCell(item[df.id], item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, ta.detail)}>详情</div>
                {item.status === Status.INIT && <div className={styles.item} onClick={() => tableAction(key, ta.edit, item)}>编辑</div>}
                {item.status === Status.INIT && <div className={styles.item} onClick={() => tableAction(key, ta.sure, item)}>确认收款</div>}
            </div>
        );
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRowKeys, selectedRows });
            this.props.tableAction([...selectedRowKeys], ta.batch);
        },
    };

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={df.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;